import { createApiClient } from '@drama/api-sdk'
import { createLocalTokenStore } from '@drama/app-boot/vg-token-store'

/**
 * @param {{ baseUrl: string, getLocale?: () => string, fetchImpl?: typeof fetch }} opts
 */
export function createVisualGameClient(opts) {
  if (!opts || typeof opts.baseUrl !== 'string') {
    throw new Error('createVisualGameClient: opts.baseUrl is required')
  }
  const authExpiredHandlers = new Set()
  let client
  const tokenStore = createLocalTokenStore({
    refreshSession: request => client.auth.refresh(request),
    deviceKey: 'visualGame.deviceId',
    devicePrefix: 'vg-dev-',
  })
  function notifyAuthExpired() {
    tokenStore.clear?.()
    for (const handler of authExpiredHandlers) handler()
  }
  client = createApiClient({
    baseUrl: opts.baseUrl,
    tokenStore,
    onAuthExpired: notifyAuthExpired,
    getLocale: opts.getLocale,
    fetchImpl: opts.fetchImpl,
  })
  return Object.assign(client, {
    tokenStore,
    onAuthExpired(handler) {
      if (typeof handler !== 'function') return () => {}
      authExpiredHandlers.add(handler)
      return () => authExpiredHandlers.delete(handler)
    },
  })
}
